import React from 'react';
import { useTx } from '../hooks/useTx';
import { usd, fromUSDT } from '../utils/format';

const POOLS = [
  { key: 'silver', name: 'Silver Pool', cls: 'pool-silver', mark: 'S', method: 'claimSilverPoolIncome', elig: 'silverEligible', claim: 'silverClaimable' },
  { key: 'gold', name: 'Gold Pool', cls: 'pool-gold', mark: 'G', method: 'claimGoldPoolIncome', elig: 'goldEligible', claim: 'goldClaimable' },
  { key: 'diamond', name: 'Diamond Pool', cls: 'pool-diamond', mark: 'D', method: 'claimDiamondPoolIncome', elig: 'diamondEligible', claim: 'diamondClaimable' },
  { key: 'special', name: 'Special Bonus', cls: 'pool-special', mark: '★', method: 'claimSpecialPoolIncome', elig: 'specialEligible', claim: 'specialClaimable' },
];

export default function Pools({ data }) {
  const { run, pending } = useTx();
  const elig = data.eligibility || {};
  const claimable = data.claimablePools || {};

  const claim = (pool) =>
    run({
      method: pool.method,
      args: [],
      successMsg: `${pool.name} claimed!`,
      onDone: data.refresh,
    });

  return (
    <div className="tab fade-in">
      <div className="section-title"><span className="bar" />Reward Pools</div>

      <div style={{ display: 'grid', gap: 12 }}>
        {POOLS.map((p) => {
          const isElig = !!elig[p.elig];
          const amt = claimable[p.claim];
          const hasAmt = amt && fromUSDT(amt) !== '0';

          return (
            <div key={p.key} className={`card pool ${p.cls}`}>
              <div className="card-row">
                <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
                  <div className="ring">{p.mark}</div>
                  <div>
                    <div style={{ fontWeight: 700, fontSize: 15 }}>{p.name}</div>
                    <div style={{ marginTop: 4 }}>
                      {isElig ? (
                        <span className="pill ok">Eligible</span>
                      ) : (
                        <span className="pill off">Not eligible</span>
                      )}
                    </div>
                  </div>
                </div>
                <div style={{ textAlign: 'right' }}>
                  <div className="stat-label">Claimable</div>
                  <div className="stat-value" style={{ fontSize: 18 }}>{usd(amt)}</div>
                </div>
              </div>

              <div style={{ marginTop: 14 }}>
                <button
                  className="btn sm"
                  style={{ width: '100%' }}
                  onClick={() => claim(p)}
                  disabled={pending || !isElig || !hasAmt}
                >
                  {pending ? <span className="spin-inline" /> : null}
                  {!isElig ? 'Not Eligible' : !hasAmt ? 'Nothing to Claim' : 'Claim'}
                </button>
              </div>
            </div>
          );
        })}
      </div>

      <p className="dim" style={{ fontSize: 12, textAlign: 'center', marginTop: 18, lineHeight: 1.5 }}>
        Eligibility unlocks as you activate the required packages. Silver: 1–4 · Gold: 1–6 · Diamond: all 9 · Special: one-shot join/topup.
      </p>
    </div>
  );
}
